import React from 'react';
import { connectStateResults } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import LoadingArea from '@molecules/LoadingArea';
import { H4 } from '@styled';

const SearchState = ({ hitCount, isSearchStalled, NoResultsText = () => <>No results found.</> }) => {
    if (isSearchStalled) {
        return <LoadingArea />;
    }

    if (hitCount === 0) {
        return (
            <div className="pt-1rem" style={{ height: '30vh' }}>
                <H4>
                    <NoResultsText />
                </H4>
            </div>
        );
    }

    return null;
};

SearchState.propTypes = {
    hitCount: PropTypes.number.isRequired,
    isSearchStalled: PropTypes.bool.isRequired,
    NoResultsText: PropTypes.elementType,
};

export default connectStateResults(SearchState);
